import { baseApi } from "../../../services/rtkApi/baseApi";
import { SERVER_URL } from "../../../config/env";

/** GET /api/welcome (n450s_backend routes/user/welcome.ts) */
export interface WelcomeStatus {
  /** true for a new account that hasn't been through the welcome screen */
  show: boolean;
  username: string;
  emoji: string | null;
  birthday: string | null;
}

export const welcomeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getWelcome: builder.query<WelcomeStatus, void>({
      query: () => "/welcome",
      keepUnusedDataFor: 0,
    }),
    finishWelcome: builder.mutation<{ ok: boolean }, void>({
      query: () => ({ url: "/welcome/done", method: "POST" }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetWelcomeQuery, useFinishWelcomeMutation } = welcomeApi;

/**
 * Asked by the OAuth callback right after the code exchange, before the store
 * has settled, so it takes the fresh access token directly. Any failure or a
 * slow answer means "no": the welcome screen must never hold up a sign-in.
 */
export async function shouldShowWelcome(accessToken: string, timeoutMs = 3000): Promise<boolean> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const base = SERVER_URL ? `${SERVER_URL}/api` : "/api";
    const res = await fetch(`${base}/welcome`, {
      headers: { Authorization: `Bearer ${accessToken}` },
      signal: controller.signal,
    });
    if (!res.ok) return false;
    const body = (await res.json()) as Partial<WelcomeStatus>;
    return body?.show === true;
  } catch {
    return false;
  } finally {
    clearTimeout(timer);
  }
}
